import { apiClient } from './client'

// Confirms that the Teams account behind the link the bot sent is the person
// signed in to Regen (REG-412).
export async function linkTeamsAccount(token: string): Promise<void> {
  await apiClient.post('/api/v1/me/teams-link', { token })
}
